export default "__VITE_ASSET__DipP4Oqp__"